import React from 'react';
import styles from 'signer-app/signature-modal/common/tab-icon-container.module.css';
import { Box } from '@dropbox/dig-foundations';
import { useFeatureFlag } from '../../../js/sign-components/common/feature-flag';

interface TabIconContainerProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  isMobile?: boolean;
}

export const TabIconContainer = ({
  icon,
  children,
  isMobile,
}: TabIconContainerProps) => {
  const isNewSignerApp = useFeatureFlag('sign_core_20240330_new_signer_app');

  if (isNewSignerApp) {
    return (
      <div className={styles.tabIconContainer}>
        {icon}
        <Box display={{ xsmall: 'none', small: 'block' }}>{children}</Box>
      </div>
    );
  }

  return (
    <div className={styles.tabIconContainer}>
      {icon} {!isMobile && children}
    </div>
  );
};
